import Echo from 'laravel-echo';
import { mapMutations, mapState } from 'vuex';
import Thread from '../lib/models/Thread';
import Message from '../lib/models/Message';
import Global from './Global';

export default {
    name: 'NotificationCentre',
    mixin: [Global],
    data() {
        return {
            user_typing: null,
            typing: false,
            incomingMessage: false,
            thread_id: null
        }
    },
    computed: {
        ...mapState(['inboxCount', 'privateChannel']),

        getIncomingMessage() {
            return this.incomingMessage;
        },
    },
    methods: {
        ...mapMutations(['setPrivateChannel']),

        checkUnreadMessages() {
            if(this.inboxCount > 0) {
                this.incomingMessage = true;
            }
        },
        listenForWhisper(threadId) {
            let timer;
            window.Echo.private(`chat.${threadId}`).listenForWhisper('typing', (e) => {
                this.user_typing = e.user_id;
                this.typing = e.typing;
                let _this = this;

                clearTimeout(timer);

                // remove is typing indicator after 0.9s
                timer = setTimeout(function() {
                    _this.typing = false
                }, 900);
            });
        },
        whisper(threadId) {
            setTimeout(() => {
                window.Echo.private(`chat.${threadId}`).whisper('typing',
                {
                    user_id: self.user.id,
                    typing: true,
                });
            }, 500);
        },
        openPresenceChannel(threadId) {
            window.Echo.join(`chat.${threadId}`)
                .here((users) => {
                    Thread.update({
                        where: threadId,
                        data: { presence: users }
                    })
                })
                .joining((user) => {
                    const chat = Thread.find(threadId);
                    const presence = chat.presence;
                    presence.push(user);
                    Thread.api().updateLastActivity(threadId, user.id);
                    Thread.update({
                        where: threadId,
                        data: { presence }
                    })
                })
                .leaving(async (user) => {
                    const chat = Thread.find(threadId);
                    const presence = chat.presence.filter(u => (u.id !== user.id))
                    Thread.api().updateLastActivity(threadId, user.id);
                    Thread.update({
                        where: threadId,
                        data: { presence }
                    })
                });
        }
    },
    mounted(){
       this.checkUnreadMessages();
    },
}
